export function IconBookmark() {
    return (
        <svg width="12" height="12" viewBox="0 0 12 12">
            <path fill="currentColor" fillRule="evenodd" d="M2 2.5a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v7.293a.5.5 0 0 1-.854.353L6.707 7.707a1 1 0 0 0-1.414 0l-2.44 2.44A.5.5 0 0 1 2 9.792V2.5zM3 0h6a2.5 2.5 0 0 1 2.5 2.5v7.293c0 1.782-2.154 2.674-3.414 1.414L6.354 9.475a.5.5 0 0 0-.708 0l-1.732 1.732C2.654 12.467.5 11.575.5 9.793V2.5A2.5 2.5 0 0 1 3 0z"/>
        </svg>
    );
}
